<template>
    <div id="portfolio-information" class="tab-pane fade">
        <div class="row">
            <div v-if="hasPorfolios" class="col-xl-3 col-lg-6 col-md-6 mb-4" v-for="(portfolio, index) in portfolios" :key="index">
                <portfolio-card-component :portfolio="portfolio"/>
            </div>
            <div v-if="!hasPorfolios" class="col-xl-3 col-lg-6 col-md-6 mb-4">
                <router-link class="card new-portfolio" :to="{ name: 'portfolios.create' }">
                    <div class="card-body">
                        <div class="justify-content-center my-5">
                            <div class="wd-100 wd-sm-120 m-auto">
                                <img :src="plus" class="img-fluid" alt="">
                            </div>
                            <p class="tx-center mt-3">Create Client Portfolio</p>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<style scoped>
	.card-body {
		padding: 25px;
	}

	.new-portfolio {
		vertical-align: middle;
		align-items: center;
		border: none;
		font-size: 17.5px;
		color: #f4911e !important;
		transition: all 0.2s ease-in-out;
	}

	.new-portfolio:hover {
		transform: scale(1.1);
	}
</style>

<script>
	import plus from '../../../../../../img/plus.svg'

	export default {
		data() {
			return {
				plus
			}
		},
		computed: {
			hasPorfolios() {
				return this.portfolios.length;
			}
		},
		props: ["portfolios"]
	};
</script>